import { IFundSearchResult } from '../types';
const dummyData: IFundSearchResult = {
  funds: [
    {
      code: '12345678',
      name: '1234567890',
      entityType: 'smsf',
      businessCode: 'CLASS',
      url: 'f/CLASS/12345678',
      hitKind: 1,
    },
    {
      code: '123456789Findex',
      name: '123456789Findex',
      entityType: 'portfolio',
      businessCode: 'Hardi',
      url: 'f/Hardi/123456789Findex',
      hitKind: 1,
    },
    {
      code: 'TEST12345678',
      name: 'TEST12345678',
      entityType: 'trust',
      businessCode: 'SmartSuper',
      url: 'f/SmartSuper/TEST12345678',
      hitKind: 1,
    },
    {
      code: '12345678',
      name: 'Bank account only',
      entityType: 'smsf',
      businessCode: 'SmartSuper',
      url: 'f/SmartSuper/12345678',
      hitKind: 2,
    },
    {
      code: '123456789',
      name: 'Bank account 3',
      entityType: 'portfolio',
      businessCode: 'SmartSuper',
      url: 'f/SmartSuper/123456789',
      hitKind: 2,
    },
    {
      code: '1234567899',
      name: 'Bank account 2',
      entityType: 'trust',
      businessCode: 'SmartSuper',
      url: 'f/SmartSuper/1234567899',
      hitKind: 2,
    },
    {
      code: '12345678998',
      name: 'Bank account only',
      entityType: 'smsf',
      businessCode: 'SmartSuper',
      url: 'f/SmartSuper/12345678998',
      hitKind: 2,
    },
    {
      code: '123456789AAAA',
      name: 'Rate setter account holder',
      entityType: 'portfolio',
      businessCode: 'SmartSuper',
      url: 'f/SmartSuper/123456789AAAA',
      hitKind: 2,
    },
    {
      code: 'TestLongFundName',
      name: 'Test Long Fund Name ABCDEFGHIJKLMNOPQRSTUVWXYZ 1234567891011121314151617181920',
      entityType: 'smsf',
      businessCode: 'Emily2',
      url: 'f/Emily2/TestLongFundName',
      hitKind: 3,
    },
    {
      code: 'TestLongFundName1',
      name: 'Test Long Fund Name ABCDEFGHIJKLMNOPQRSTUVWXYZ 1234567891011121314151617181920 1',
      entityType: 'trust',
      businessCode: 'Emily2',
      url: 'f/Emily2/TestLongFundName',
      hitKind: 3,
    },
  ],
  searchString: '12345678',
};
export default dummyData;
